import Link from "next/link";

const AfterInitialSettingsNavi = () => {
  return (<>
    <div className='text-xl p-5 border bg-white mb-5'>
      <p>
        すぐに利用する方は
        <Link href="/tickets" className='text-2xl text-blue-500 font-bold'>
           お問い合せ一覧ページ
        </Link>
        から新規お問い合せを追加してみましょう。
      </p>
    </div>
    <div className='text-xl p-5 border bg-white mb-5'>
      <p>
        より詳細な設定をする方は
        <Link href="/settings" className='text-2xl text-blue-500 font-bold'>
           設定ページ
        </Link>
        からカスタマイズをしてみましょう。
      </p>
    </div>
  </>)
}

export default AfterInitialSettingsNavi;